import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { minMediaQueries, ieMediaQuery } from '@finect/tabular-utils/mediaQueries';
import { grid } from '@finect/tabular-utils/grid';
export var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-gakc7u-0"
})(["width:100%;padding:30px 15px;margin:0 auto;color:", ";", " ", ";", ";", ";", ";", ";", ";"], function (_ref) {
  var color = _ref.color;
  return color ? color : 'currentColor';
}, function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor && "background-color: ".concat(backgroundColor, ";");
}, ieMediaQuery(_templateObject || (_templateObject = _taggedTemplateLiteral(["min-height: 1px;"]))), minMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    "])), function (_ref3) {
  var noPaddingQuery = _ref3.noPaddingQuery;
  return noPaddingQuery ? 'padding-top: 0' : null;
}), minMediaQueries.miniDesktop(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    max-width: ", ";\n    "])), function (_ref4) {
  var fullWidth = _ref4.fullWidth,
    smallMargin = _ref4.smallMargin;
  return fullWidth ? '100%' : smallMargin ? '95%' : "".concat(grid(8.5), "px");
}), minMediaQueries.desktop(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    max-width: ", ";\n    "])), function (_ref5) {
  var fullWidth = _ref5.fullWidth,
    smallMargin = _ref5.smallMargin;
  return fullWidth ? '100%' : smallMargin ? '90%' : "".concat(grid(8), "px");
}), minMediaQueries.bigScreen(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    max-width: ", ";\n    "])), function (_ref6) {
  var fullWidth = _ref6.fullWidth,
    smallMargin = _ref6.smallMargin;
  return fullWidth ? '100%' : smallMargin ? '90%' : "".concat(grid(8.9), "px");
}), minMediaQueries.hugeScreen(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    max-width: ", ";\n    padding-left: 30px;\n    padding-right: 30px;\n    "])), function (_ref7) {
  var fullWidth = _ref7.fullWidth;
  return fullWidth ? '100%' : "".concat(grid(10), "px");
}));